<!--  -->
<template>
  <cc-container>
    <cc-header-nav :title="$route.query.id?'编辑地址':'新增地址'">
      <template slot="right">
        <div  class="ellipsis" v-if="!$route.query.id">
          <van-icon class="ellipsis-icon" name="ellipsis" @click.stop="isShowSmallNav = !isShowSmallNav" />
        </div>
        <span v-else class="del" @click="handlerDel">删除</span>
      </template>
    </cc-header-nav>
    <cc-main>
      <div class="wrap">
        <van-field
          v-model="form.title"
          type="text"
          label="收货单位"
          placeholder="请填写收货单位名称"
          required
        />
        <van-field
          v-model="form.contacter"
          type="text"
          label="收货人"
          placeholder="请填写收货人姓名"
          required
        />
        <van-field
          v-model="form.mobile"
          type="text"
          label="手机号码"
          placeholder="请填写收货人手机号"
        />
        <van-field
          v-model="form.tel"
          type="text"
          label="固定电话"
          placeholder="请填写收货人固定电话"
        />
        <van-field
          v-model="form.regionAddress"
          type="text"
          label="所在地区"
          readonly
          placeholder="省市区县，乡镇等"
          right-icon="arrow"
          @click.native="show =true"
          required
        />
        <van-field
          v-model="form.address"
          type="text"
          label="详细地址"
          placeholder="街道，楼牌号等"
          required
        />
        <van-field
          class="mt5"
          v-model="form.remarks"
          type="text"
          label="备注"
          placeholder="选填"
        />
      </div>
      <div class="default-address">
        <div>
          <p class="address-title">设置默认地址</p>
          <p class="msg">提醒：每次下单会默认推荐使用该地址</p>
        </div>
        <van-switch
          :active-color="theme['APP_theme_color']"
          v-model="form.is_default"
          size="24px"
        />
      </div>
      <div class="save" @click="save">保存</div>
    </cc-main>
    <cc-small-nav v-model="isShowSmallNav"/>
    <van-popup v-model="show" position="bottom">
      <van-picker
        show-toolbar
        class="picker"
        :columns="columns"
        @change="onChange"
        @cancel="show = false"
        @confirm="onConfirm"
        />
    </van-popup>
  </cc-container>
</template>

<script>
import Vue from 'vue'
import { getTheme } from '@/assets/styles/theme.js'
import { Field, Icon, Switch, Picker, Popup, Toast, Dialog } from 'vant'
import { loadAddressDeatil, delAddress, loadRegion, updateAddress, addAddress } from '@/fetch/manage-center/receiver-address'
import { ResultCode } from '~const/ResultCode'
import { verification, SessionStorage } from '@/utils'
Vue.use(Field)
  .use(Icon)
  .use(Switch)
  .use(Picker)
  .use(Popup)
  .use(Dialog)

export default {
  components: {},

  props: {},

  data () {
    return {
      form: {
        title: '', // 收货单位
        contacter: '', // 收货人
        mobile: '', // 手机号码
        address: '', // 详细地址
        remarks: '', // 备注
        regionAddress: '',
        is_default: false
      },
      show: false,
      checked: false,
      isShowSmallNav: false,
      provinceList: {},
      provinceIndex: 0,
      citysList: {},
      citysIndex: 0,
      areaList: {},
      areaIndex: 0,
      region: []
    }
  },

  computed: {
    theme () {
      return getTheme()
    },
    columns () {
      const {
        provinceList,
        citysList,
        areaList,
        provinceIndex,
        citysIndex,
        areaIndex } = this

      return [{
        values: Object.values(provinceList),
        className: 'column1',
        defaultIndex: provinceIndex
      },
      {
        values: Object.values(citysList),
        className: 'column2',
        defaultIndex: citysIndex

      },
      {
        values: Object.values(areaList),
        className: 'column3',
        defaultIndex: areaIndex
      }]
    }

  },

  watch: {},

  async created () {
    if (this.$route.query.id) {
      await this.loadData()
    }
    this.getRegionList()
  },

  methods: {
    onConfirm (values, index) {
      this.form.regionAddress = values.join('')
      this.form.province_id = this.findKey(this.provinceList, values[0])
      this.form.city_id = this.findKey(this.citysList, values[1])
      this.form.area_id = this.findKey(this.areaList, values[2])
      this.show = false
    },
    async loadData () {
      let { status, data } = await loadAddressDeatil({
        address_id: this.$route.query.id
      })
      if (status === ResultCode.SUCCESS) {
        this.form = data.address_info
        this.form.is_default = +data.address_info.is_default === 1
        this.region = [data.address_info.province_id, data.address_info.city_id, data.address_info.area_id]
        this.form.regionAddress = `${data.address_info.province_name}${data.address_info.city_name}${data.address_info.area_name}`
      }
    },
    async getRegion (parent_id = 0) {
      let res = await loadRegion({
        parent_id
      })
      return res.data.region
    },
    /**
     * @description 切换地区
     * */
    async onChange (picker, values, index) {
      if (index === 0) {
        let provincId = this.findKey(this.provinceList, values[0])
        let res = await this.getRegion(provincId)
        this.citysList = {}
        res.forEach(async (item, index) => {
          this.citysList[item.id] = item.name
          if (index === 0) {
            let data = await this.getRegion(item.id)
            this.areaList = {}
            data.forEach(item => {
              this.areaList[item.id] = item.name
            })
          }
        })
      } else if (index === 1) {
        let cityId = this.findKey(this.citysList, values[1])
        let res = await this.getRegion(cityId)
        this.areaList = {}
        res.forEach(item => {
          this.areaList[item.id] = item.name
        })
      }
    },
    /**
     * @description 获取省市区
    */
    async getRegionList () {
      let { region } = this
      let res = await this.getRegion()
      this.provinceList = {}
      res && res.forEach((item, index) => {
        this.provinceList[item.id] = item.name
      })
      if (region.length > 0) { // 如果已经存在省市区
        this.provinceIndex = this.findIndex(region[0], 0)
        let cityRes = await this.getRegion(region[0])
        this.citysList = {}
        cityRes.forEach(item => {
          this.citysList[item.id] = item.name
        })
        this.citysIndex = this.findIndex(region[1], 1)
        let areaRes = await this.getRegion(region[1])
        this.areaList = {}
        areaRes.forEach(item => {
          this.areaList[item.id] = item.name
        })
        this.areaIndex = this.findIndex(region[2], 2)
      } else {
        let cityRes = await this.getRegion(Object.keys(this.provinceList)[0])
        this.citysList = {}
        cityRes.forEach(async (item, k) => {
          this.citysList[item.id] = item.name
          if (k === 0) {
            let areaRes = await this.getRegion(item.id)
            this.areaList = {}
            areaRes.forEach(item => {
              this.areaList[item.id] = item.name
            })
          }
        })
      }
    },
    findIndex (id, type) {
      let types = ['provinceList', 'citysList', 'areaList']
      return Object.keys(this[types[type]]).findIndex(item => {
        return +item === +id
      })
    },
    findKey (obj, value, compare = (a, b) => a === b) {
      return Object.keys(obj).find(k => compare(obj[k], value))
    },
    async save () {
      const { form } = this
      const obj = {
        title: '请填写收货单位名称',
        contacter: '请填写收货人姓名',
        regionAddress: '请填写所在地区',
        address: '请填写详细地址'
      }
      for (let i in obj) {
        if (!form[i]) {
          Toast(obj[i])
          return
        }
      }
      if (!form.tel && !form.mobile) {
        Toast('手机号码和固定电话必填一个')
        return
      }
      if (form.mobile && !verification('mobile', form.mobile)) {
        Toast('手机号码格式有误')
        return
      }
      if (form.tel && !verification('telephone', form.tel)) {
        Toast('固定电话格式有误')
        return
      }

      const params = { ...form }
      params.is_default = form.is_default ? '1' : '0'
      if (this.$route.query.id) {
        let { status } = await updateAddress(params)
        if (status === ResultCode.SUCCESS) {
          this.handlerSuccess()
        } else {
          Toast('操作失败')
        }
      } else {
        let { status, data } = await addAddress(params)
        if (status === ResultCode.SUCCESS) {
          this.handlerSuccess(data)
        } else {
          Toast('操作失败')
        }
      }
    },
    handleItemChangeAddress (val) {

    },
    handlerDel () {
      Dialog.confirm({
        message: '您确定要删除该地址吗？',
        title: ' ',
        beforeClose: async (action, done) => {
          if (action === 'confirm') {
            let { status } = await delAddress({
              address_id: this.$route.query.id
            })
            if (status === ResultCode.SUCCESS) {
              this.handlerSuccess()
            } else {
              Toast('操作失败')
            }
            done()
          } else {
            done()
          }
        }
      })
    },
    handlerSuccess (data) {
      Toast({
        message: '操作成功',
        duration: 1000
      })
      this.timer = setTimeout(() => {
        if (SessionStorage.getItem('newAddress')) {
          this.$router.push(`/shopping-cart/purchase`)
          return
        }
        this.$router.go(-1)
      }, 1000)
    }
  },
  beforeDestroy () {
    clearTimeout(this.timer)
    SessionStorage.removeItem('newAddress')
  }
}

</script>
<style lang='scss' scoped>
.wrap{
  border-radius: 10px;
  overflow: hidden;
  margin: 10px;
}
.save{
  width: 355px;
  height: 35px;
  border-radius: 17px;
  background: var(--APP_theme_color);
  margin: auto;
  color: #FFFFFF;
  font-size: 15px;
  @include center()

}
.default-address{
  padding: 0 10px 10px;
  display: flex;
  justify-content: space-between;
  color: #333333;
  .address-title{
    font-size: 12px;
  }
  .msg{
    font-size: 10px;
  }
}
.ellipsis{
  width: 100%;
  height: 100%;
  @include center();
  &-icon{
    transform: rotate(90deg);
  }
}
.picker{
  /deep/{
    .van-picker__frame{
      position: absolute!important;
    }
  }
}
.del{
  font-size: 14px;
}
</style>
